import { useEffect, useRef } from "react";
import { Bold, Italic, Underline, List, ListOrdered } from "lucide-react";

export function RichTextEditor({ html, onChange }) {
  const ref = useRef(null);
  useEffect(() => { if (ref.current && ref.current.innerHTML !== (html || "")) ref.current.innerHTML = html || ""; }, []); // eslint-disable-line
  const emit = () => { if (ref.current) onChange(ref.current.innerHTML); };
  const exec = (cmd, val) => { if (!ref.current) return; ref.current.focus(); document.execCommand(cmd, false, val); emit(); };
  const Btn = ({ cmd, val, icon: Icon, label }) => <button type="button" onMouseDown={(e) => { e.preventDefault(); exec(cmd, val); }} title={label} className="rounded p-1.5 text-navy hover:bg-slate-100"><Icon size={15} /></button>;
  return (
    <div className="rounded-lg border border-slate-300">
      <div className="flex flex-wrap items-center gap-0.5 border-b border-slate-200 bg-slate-50 px-2 py-1.5">
        <select onChange={(e) => exec("formatBlock", e.target.value)} defaultValue="p" className="mr-1 rounded border border-slate-300 bg-white px-1.5 py-1 text-xs text-navy">
          <option value="p">Paragraph</option><option value="h1">Heading 1</option><option value="h2">Heading 2</option><option value="h3">Heading 3</option>
        </select>
        <Btn cmd="bold" icon={Bold} label="Bold" />
        <Btn cmd="italic" icon={Italic} label="Italic" />
        <Btn cmd="underline" icon={Underline} label="Underline" />
        <span className="mx-1 h-4 w-px bg-slate-300" />
        <Btn cmd="insertUnorderedList" icon={List} label="Bullet list" />
        <Btn cmd="insertOrderedList" icon={ListOrdered} label="Numbered list" />
      </div>
      <div ref={ref} contentEditable suppressContentEditableWarning onInput={emit} data-testid="gendoc-edit-body" className="apex-doc min-h-[300px] max-h-[440px] overflow-y-auto px-5 py-4 text-sm leading-relaxed text-navy outline-none" />
    </div>
  );
}
